import type { AuditIndexItem } from "@/types";
import AuditListRow from "./AuditListRow";

export default function AuditsList({ audits }: { audits: AuditIndexItem[] }) {
  return (
    <div id="audits-list" className="card scroll-mt-5 bg-white">
      {audits.map((audit) => (
        <AuditListRow key={audit.id} audit={audit} />
      ))}
    </div>
  );
}
